var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuegos(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_806_453)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7458 5.46822C13.7458 4.70886 13.9304 3.99302 14.2553 3.36123H6.72237L6.72237 10.8941C6.09053 10.5691 5.37468 10.3846 4.61539 10.3846C2.06637 10.3846 0 12.451 0 15C0 17.549 2.06637 19.6154 4.61539 19.6154C5.37475 19.6154 6.09059 19.4308 6.72237 19.1059L6.72237 26.6388H14.2552C13.9303 26.0069 13.7457 25.2911 13.7457 24.5318C13.7457 21.9828 15.8121 19.9164 18.3611 19.9164C20.9101 19.9164 22.9765 21.9828 22.9765 24.5318C22.9765 25.2912 22.792 26.007 22.467 26.6388L30 26.6388V3.36123L22.4672 3.36123C22.7921 3.99308 22.9766 4.70893 22.9766 5.46822C22.9766 8.01723 20.9103 10.0836 18.3613 10.0836C15.8122 10.0836 13.7458 8.01723 13.7458 5.46822Z",
    fill: "#359C4F",
    stroke: "white",
    strokeWidth: 0.43956
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_806_453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#359C4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuegos);
export default __webpack_public_path__ + "static/media/juegos.1073282ac092691f7bfadbb0eb3c4528.svg";
export { ForwardRef as ReactComponent };